import { createElement, memo, PropsWithChildren } from "react";
import classNames from "classnames";
import { Link, LinkProps } from "react-router";

import styles from "./style.module.scss";

// const preventLinkClick = (e: MouseEvent<HTMLAnchorElement>) => {
//   if (e.target === e.currentTarget){
//     e.preventDefault();
//   }
//   else {
//     debugger;
//   }
// };

export type RowComponentProps = PropsWithChildren<LinkProps & {}>
export const RowComponent = memo<RowComponentProps>(({ to, className, children, ...restProps }) => {
  const isLink = false;//!!to;
  return createElement(
    isLink ? Link : "div",
    {
      to,
      className: classNames(className, styles.root),
      ...restProps,
      // onClickCapture: restProps.onClick
      //   ? restProps.onClick
      //   : (isLink ? preventLinkClick : undefined)
    },
    children,
  );
});

export default RowComponent;
